core.component('core.drawflowComponent', {
    templateUrl: 'components/drawflow/drawflow.html',
    controller: 'drawflowController',
    bindings: { flowItems: '=', exportData: '=', viewMode: '=' }
});

core.controller('drawflowController', ['$scope', '$state', 'coreLanguage', 'coreFb', 'coreDialog', '$timeout', '$interval', '$filter', function($scope, $state, $text, $fb, $dialog, $timeout, $interval, $filter) {
    const $ctrl = this;
    $scope.$text = $text;

    $ctrl.selectedNode = null;
    $ctrl.iniciado = false;
    $ctrl.rotaFluxo = 'consoleApp.editFluxo';

    const _reindex=(items)=>{
        let changed = {};
        let newItems = {};

        Object.values(items).forEach((item, key)=>{
            if(item.id !== key + 1){ changed[item.id] = key + 1; }
            newItems[key+1] = null;
        });

        Object.values(items).forEach((item, key)=>{
            if(changed[item.id] >=0){
                item.id = changed[item.id];
            };

            Object.values(item.inputs).forEach((inputValue)=>{
                inputValue.connections.forEach((conn)=>{
                    if(changed[conn.node] >=0){
                        conn.node = String(changed[conn.node]);
                    }
                });
            });
            
            Object.values(item.outputs).forEach((outputValue)=>{
                outputValue.connections.forEach((conn)=>{
                    if(changed[conn.node] >=0){
                        conn.node = String(changed[conn.node]);
                    }
                });
            });

            newItems[key+1] = item;
        });

        return newItems;

    };

    const _getDominio=()=>{
        ///Necessário para garantir que dados estejam carregados 
        //antes de registrar items do drawflow
        return new Promise((resolve, reject)=>{
            $ctrl.tags = [];
            $ctrl.userFlows = [];
            $ctrl.flowDefaults = [];
            $ctrl.leads = [];
            $ctrl.fluxo = null;

            $ctrl.emojiOptions = ['❤','😁','😍','😎','🤩','😥','😡','👍','👏','🙏','🚀'];

            const idFluxo = $state.params.idFluxo;

            $fb.db.get('dominio/flowDefaults').then(flowDoc=>{
                $ctrl.flowDefaults = flowDoc.data.values;
                $ctrl.condicao = flowDoc.data.condicoes;
                $ctrl.filtros = flowDoc.data.filtros;

                return $fb.db.list('cad_tags', [{ where: ['criacao.idUsuario', '==', $ctrl.idUsuario] }]);
            }).then(list=>{ 
                list.forEach(item=>{ $ctrl.tags.push({nome:item.data.nome, cor: item.data.cor}); }); 

                //Adiciona Tag como padrão no item Tags
                let tagItem = $ctrl.flowDefaults.filter(item=> item.type === 'tags')[0];
                if(tagItem && $ctrl.tags.length){ tagItem.value.tag = $ctrl.tags[0].nome };

                return $fb.db.list('cad_fluxos', [{ where: ['criacao.idUsuario', '==', $ctrl.idUsuario] }]);
            }).then(list=>{ 
                list.forEach(item=>{ 
                    $ctrl.userFlows.push({id: item.id, title: item.data.nome }); 
                    if(item.id === idFluxo){ $ctrl.fluxo = {id: item.id, ativo: item.data.ativo }; }
                }); 

                return _getModelos();

            }).then(okay=>{
                if($ctrl.viewMode && !!idFluxo){
                    //return $fb.functions.invoke('flow_getIndicadores', {idFluxo: idFluxo})
                    _watchEnvios();
                }

                resolve();
                
            });

        });
    };

    const _getModelos=()=>{
        return new Promise((resolve, reject)=>{
            $ctrl.userModels = [];
            $fb.db.list('cad_modelos', [{ where: ['criacao.idUsuario', '==', $ctrl.idUsuario] }]).then(list=>{ 
                list.forEach(item=>{ $ctrl.userModels.push({...item.data, id: item.id }); }); 
                resolve();
            });
        });
    };

    const _cancelWatchers=()=>{
        if($ctrl.unsubEnvios){ $ctrl.unsubEnvios(); }
        if($ctrl.envioWatcher){ $timeout.cancel($ctrl.envioWatcher); }
        if($ctrl.envioInterval){ $interval.cancel($ctrl.envioInterval); }
        return;
    }

    const _watchEnvios=()=>{
        if(!$ctrl.viewMode){
            return;
        }

        const idFluxo = $state.params.idFluxo;
        $ctrl.gettingEnvios = false;

        let dataInicio = new Date();
        dataInicio.setHours(0, 0, 0, 0);

        $ctrl.counter = 0;

        const _getIndicadores=()=>{
            $fb.functions.invoke('flow_getIndicadores', {idFluxo: idFluxo}).then(res=>{
                $ctrl.leads = res;
                $ctrl.leads.forEach((item, idx)=>{ if(idx){ _checkDomChanges(idx, true); }});
                $ctrl.gettingEnvios = false;
            });
        }

        return $fb.db.listen('envios_fluxo', [{ where: ['idFluxo', '==', idFluxo]}, {where: ['criacao.data', '>', dataInicio] }], (action, item) => {
            if($state.current.name !== $ctrl.rotaFluxo || !$ctrl.viewMode){ 
                _cancelWatchers(); 
                return;
            }

            if(!$ctrl.gettingEnvios){
                $ctrl.gettingEnvios = true;

                if(!$ctrl.leads.length){ 
                    $ctrl.leads = [0];
                    _getIndicadores(); 
                }else{ 

                    if($ctrl.envioWatcher){ 
                        $timeout.cancel($ctrl.envioWatcher); 
                        $ctrl.counter++;
                    }

                    $ctrl.seconds = $ctrl.leads.length > 100 ? 30 : 15;

                    $ctrl.envioWatcher = $timeout(()=>{ 
                        if($ctrl.envioInterval){ $interval.cancel($ctrl.envioInterval); }
                        $ctrl.envioInterval = $interval(()=>{ 
                            if($state.current.name !== $ctrl.rotaFluxo || !$ctrl.viewMode){ 
                                _cancelWatchers(); 
                                return;
                            }
                            
                            _getIndicadores(); 
                            $ctrl.counter = 0;

                        }, $ctrl.seconds * 1000);

                    }, 1000);
                }
            }

        }).then((data) => {
            $ctrl.unsubEnvio = data[0];
        });

    };

    const _regDefaultNodes=()=>{

        const _registerStartNode=()=>{
            let htmlItem = `
            <div class="avtar avtar-s bg-warning flex-shrink-0 rounded-circle" title="${ $text.flowStart }">
                <i class="fs-3 ph-duotone ph-flag text-white"></i>
            </div>`;

            if($ctrl.viewMode){
                htmlItem += `<div class="bg-success fs-3 p-2 rounded text-white text-center leads-in-step d-none" title="${ $text.leadsIn }" style="position:absolute; top:46px; left:-50%; width:80px;"></div>`
            }

            let html = document.createElement("div");
            html.innerHTML =  htmlItem;

            $ctrl.drawEditor.registerNode('start', html);

            return;
        };

        const _getCardHeader=(item)=>{
            return `<div class="card-header p-2 py-1 d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                        <div class="avtar avtar-xs">
                            <i class="fs-5 ph-duotone d-block ${ item.icon }"></i>
                        </div>
                        <h5 class="item-title">${ item.title }</h5>
                    </div>
                </div>`;
        };

        const _getCardFooter=(item)=>{

            if(!$ctrl.viewMode){
                return `<div class="card-footer py-1 px-2 d-flex justify-content-between">
                    <button type="button" class="btn btn-icon text-danger node-remove" title="${ $text.delete }" id="item-remove">
                        <i class="ph-duotone d-block ph-trash"></i>
                    </button>
                    <div class="d-flex">
                        <button type="button" class="btn btn-icon bg-link text-dark node-copy" title="${ $text.copy }">
                            <i class="ph-duotone d-block ph-copy"></i>
                        </button>
                        <button type="button" class="btn btn-icon bg-link text-primary node-saveAsModel" title="${ $text.saveAsModel }">
                            <i class="ph-duotone d-block ph-bookmark-simple"></i>
                        </button>
                    </div>
                </div>`;

            }else{
                return `<div class="card-footer py-1 px-2 bg-success d-flex align-items-center justify-content-center leads-in-step d-none" title="${ $text.leadsInStep }"></div>`;
            }
            
        };

        const _getBodyByType=(type)=>{
            let body = {};

            body.generic = `<div class="card-body simple-exit">${ type }</div>`; 

            body.text = `
            <div class="card-body simple-exit">

                <div class="mb-3">
                    <label>${ $text.wait }</label>
                    <div class="input-group">
                        <input type="number" class="form-control form-control-sm" df-delaytempo min="0" />
                        <select class="form-select form-select-sm" df-delaymedida required>
                            ${
                                $text.timeOptions.map((item)=>{
                                    return `<option value="${ item.value }">${ item.label }</option>`;
                                }).join('')
                            }
                        </select>
                    </div>
                </div>

                <div class="mb-3">
                    <label>${ $text.timeTyping }</label>
                    <input type="number" class="form-control form-control-sm" df-tempo min="0"/>
                </div>

                <div>
                    <textarea class="form-control form-select-sm" df-texto rows="7" placeholder="${ $text.writeText }"></textarea>
                </div>
            </div>
            `;

            body.file = `
                <div class="card-body simple-exit" file-wrapper>
                    <div class="mb-3">
                        <label>${ $text.wait }</label>
                        <div class="input-group">
                            <input type="number" class="form-control form-control-sm" df-delaytempo min="0" />
                            <select class="form-select form-select-sm" df-delaymedida required>
                                ${
                                    $text.timeOptions.map((item)=>{
                                        return `<option value="${ item.value }">${ item.label }</option>`;
                                    }).join('')
                                }
                            </select>
                        </div>
                    </div>
                    <div class="file-input-wrapper" if-empty-file>
                        <div class="text-center d-flex flex-column text-primary">
                            <i class="fs-2 ph-duotone ph-upload mb-2"></i>
                            <span>${$text.fileUpload}</span>
                            <span class="spinner-border mx-auto spinner-border-sm d-none" if-loading-file></span>
                        </div>
                        <input class="position-absolute start-0 top-0 w-100 h-100 opacity-0 cursor-pointer" type="file" df-file>
                    </div>
                </div>
            `;

            body.video = body.file;
            body.image = body.file;
            body.audio = body.file;

            body.tags = `
                <div class="card-body simple-exit">
                    <div class="mb-3">
                        <label>${ $text.actions }</label>
                        <select class="form-select form-select-sm" df-action required>
                            ${
                                $text.tagOptions.map((item)=>{
                                    return `<option value="${ item.value }">${ item.label }</option>`;
                                }).join('')
                            }
                        </select>
                    </div>
                    <div>
                        <label>${ $text.tag }</label>
                        <div class="input-group" tags-selector>
                            <button class="btn btn-light-primary btn-sm ${$ctrl.viewMode ? 'd-none' : ''}" type="button" onclick="angular.element(this).scope().$ctrl.addTag()">
                                <i class="fs-5 ph-duotone ph-plus"></i>
                            </button>
                        </div>
                    </div>
                </div>
            `;

            body.delay = `
                <div class="card-body simple-exit">
                    <div class="form-check form-switch mb-3">
                        <label>
                            <input type="checkbox" class="form-check-input input-primary" df-waitmsg>
                            ${ $text.waitMessage }
                        </label>
                    </div>                    
                    
                    <div class="p-2 rounded bg-light-danger mb-3 d-none" if-waitmsg>
                        <label>${ $text.waitUntil }</label>
                        <div class="input-group">
                            <input type="number" class="form-control form-control-sm" df-waitTempo min="0"  />
                            <select class="form-select form-select-sm" df-waitMedida required>
                                ${
                                    $text.timeOptions.map((item)=>{
                                        return `<option value="${ item.value }">${ item.label }</option>`;
                                    }).join('')
                                }
                            </select>
                        </div>
                    </div>

                    <div>
                        <label>${ $text.interval }</label>
                        <div class="input-group">
                            <input type="number" class="form-control form-control-sm" df-tempo min="0" />
                            <select class="form-select form-select-sm" df-medida required>
                                ${
                                    $text.timeOptions.map((item)=>{
                                        return `<option value="${ item.value }">${ item.label }</option>`;
                                    }).join('')
                                }
                            </select>
                        </div>
                    </div>

                    <div class="mt-3 d-none" if-waitmsg>
                        <label>&nbsp;</label>
                        <div class="d-flex align-items-center">
                            <div class="form-check form-switch me-2" style="width:50%; flex:0 0 auto;">
                                <label>
                                    <input type="checkbox" class="form-check-input input-primary" df-reagir>
                                    ${ $text.reactTo }
                                </label>
                            </div>
                            <select class="form-select form-select-sm" df-reacao>
                                ${
                                    $ctrl.emojiOptions.map((item)=>{
                                        return `<option value="${ item }">${ item }</option>`;
                                    }).join('')
                                }
                            </select>
                        </div>
                    </div>

                </div>
            `;

            body.condition = `
                <div class="card-body">
                    <div>
                        <label>${ $text.event }</label>
                        <select class="form-select form-select-sm" df-evento required>
                            ${
                                $ctrl.condicao.eventos.map((item)=>{
                                    return `<option value="${ item.value }">${ item.label }</option>`;
                                }).join('')
                            }
                        </select>
                    </div>

                    <div class="p-2 rounded bg-light-dark mt-3 d-none" if-hasRegras>
                        <div if-regraCondition>
                            <label>${ $text.if }</label>
                        </div>
                        <div class="mt-2" if-regraSubcondition>
                        </div>
                    </div>

                    <div class="p-2 rounded bg-light-danger mt-3 d-none" if-enableElse>
                        <span>${ $text.else }</span>
                    </div>
                    
                </div>
            `;
            
            body.filter = `
                <div class="card-body">
                    <div class="d-none">
                        <label>${ $text.event }</label>
                        <input class="form-control form-control-sm" df-evento required />
                    </div>

                    <div class="p-2 rounded bg-light-dark mt-3 d-none" if-hasRegras>
                        <div if-regraCondition>
                            <label>${ $text.if }</label>
                        </div>
                        <div class="mt-2" if-regraSubcondition>
                        </div>
                    </div>

                    <div class="p-2 rounded bg-light-danger mt-3 d-none" if-enableElse>
                        <span>${ $text.else }</span>
                    </div>
                    
                </div>
            `;

            body.aiGenerator = `
                <div class="card-body simple-exit">
                    <div class="mb-3">
                        <label>${ $text.wait }</label>
                        <div class="input-group">
                            <input type="number" class="form-control form-control-sm" df-delaytempo min="0" />
                            <select class="form-select form-select-sm" df-delaymedida required>
                                ${
                                    $text.timeOptions.map((item)=>{
                                        return `<option value="${ item.value }">${ item.label }</option>`;
                                    }).join('')
                                }
                            </select>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label>${ $text.timeTyping }</label>
                        <input type="number" class="form-control form-control-sm" df-tempo min="0"/>
                    </div>

                    <div class="mb-3">
                        <textarea class="form-control form-select-sm" df-prompt rows="7" placeholder="${ $text.promptText }"></textarea>
                    </div>

                    <div class="form-check form-switch mb-3">
                        <label>
                            <input type="checkbox" class="form-check-input input-primary" df-lastMsg>
                            ${ $text.readLastMessage }
                        </label>
                    </div>

                    <small class="form-text text-muted">
                        <i class="fs-5 ph-duotone ph-info me-1 text-primary"></i>
                        <span>${ $text.infoAiGenerator }</span>
                    </small>
                </div>
            `;

            body.aiDecider = `
                <div class="card-body">
                    <small class="form-text text-muted">
                        <i class="fs-5 ph-duotone ph-info me-1 text-primary"></i>
                        <span>${ $text.infoAiDecider }</span>
                    </small>

                    <div class="p-2 rounded bg-light-dark mt-3">
                        <label>${ $text.intents }</label>
                        <div if-intents>
                            <div id="intent-1" class="position-relative mt-2">
                                <input type="text" class="form-control form-control-sm" df-intent-1 maxlenght="35" placeholder="${$text.writeText}" />
                            </div>
                            <div id="intent-2" class="position-relative mt-2 d-none">
                                <input type="text" class="form-control form-control-sm" df-intent-2 />
                            </div>
                        </div>
                        
                        <div class="text-center mt-2 ${ $ctrl.viewMode ? 'd-none' : ''}">
                            <button type="button" class="btn avtar-s btn-icon bg-light-primary" act-add-intent>
                                <i class="ph-duotone ph-plus"></i>
                            </button>
                        </div>
                    </div>

                    <div class="p-2 rounded bg-light-danger mt-3">
                        <span>${ $text.notProvided }</span>
                    </div>
                </div>
            `;

            body.transfer = `
                <div class="card-body">
                    <div>
                        <select class="form-select form-select-sm" df-destino required>
                            ${
                                $text.transferOptions.map((item)=>{
                                    return `<option value="${ item.value }">${ item.label }</option>`;
                                }).join('')
                            }
                        </select>
                    </div>
                    <div class="mt-3" if-destino>
                        <label>${ $text.destiny }</label>
                    </div>
                </div>
            `;

            body.finalizar = `<div class="card-body simple-exit">Finalizar</div>`; 

            return body[type] || body.generic;
        };

        $ctrl.flowDefaults.forEach((item)=>{
            let htmlItem = `
            <div class="card" style="width:300px; overflow:hidden;">
                ${ _getCardHeader(item) }

                ${ _getBodyByType(item.type) }

                ${ !item.hideOnPanel ? _getCardFooter(item) : '' }
            </div>`;

            let html = document.createElement("div");
            html.innerHTML =  htmlItem;

            $ctrl.drawEditor.registerNode(item.type, html);
        });

        _registerStartNode();
    };

    const _checkDomChanges=(id, initial=false)=>{
        if(!initial && $ctrl.viewMode){
            return;
        }

        if(initial && !$ctrl.flowItems.data[id]){
            return;
        }

        let nodeRef = $ctrl.drawEditor.getNodeFromId(id);

        let refreshConn = false;

        if(nodeRef.html === 'delay'){
            /////DELAY
            let ckBox = document.querySelector(`.drawflow-node[id='node-${ nodeRef.id }'] input[df-waitmsg]`);
            let ckBoxReact = document.querySelector(`.drawflow-node[id='node-${ nodeRef.id }'] input[df-reagir]`);
            
            if(initial){
                ckBox.checked = nodeRef.data.waitmsg === 'on' ? true : false;
                ckBoxReact.checked = nodeRef.data.reagir === 'on' ? true : false;
            };
            
            nodeRef.data.waitmsg = ckBox.checked ? 'on' : false;
            nodeRef.data.reagir = ckBoxReact.checked ? 'on' : false;

            let elems = document.querySelectorAll(`.drawflow-node[id='node-${ nodeRef.id }'] [if-waitmsg]`);
            let hasOutput = Object.keys(nodeRef.outputs).includes('output_2');

            if(ckBox.checked){
                for(let elem of elems){ elem.classList.remove('d-none'); }
                if(!hasOutput){ $ctrl.drawEditor.addNodeOutput(id); }

            }else{
                for(let elem of elems){ elem.classList.add('d-none'); }
                if(hasOutput){ $ctrl.drawEditor.removeNodeOutput(id, 'output_2'); }
            }

            $ctrl.drawEditor.updateNodeDataFromId(nodeRef.id, {...nodeRef.data, waitmsg:nodeRef.data.waitmsg});

            refreshConn = true;

        }else if(nodeRef.html === 'aiGenerator'){
            /////AI GENERATOR
            let ckBox = document.querySelector(`.drawflow-node[id='node-${ nodeRef.id }'] input[df-lastmsg]`);

            if(initial){
                ckBox.checked = nodeRef.data.lastmsg === 'on' ? true : false;
            };
            
            nodeRef.data.lastmsg = ckBox.checked ? 'on' : false;

            $ctrl.drawEditor.updateNodeDataFromId(nodeRef.id, {...nodeRef.data, lastmsg:nodeRef.data.lastmsg});

        }else if(nodeRef.html === 'transfer'){
            /////TRANSFER
            const _addFlowSelect=()=>{
                let flowSelect = document.createElement("div");
                flowSelect.innerHTML = `
                    <select class="form-select form-select-sm" if-destino-flow df-destinoId required>
                    ${
                        $ctrl.userFlows.map((item)=>{
                            return `<option value="${ item.id }">${ item.title }</option>`;
                        }).join('')
                    }
                    </select>`;

                elem.appendChild(flowSelect);
                return;
            };

            const _addStepSelect=()=>{
                let stepSelect = document.createElement("div");
                stepSelect.innerHTML = `
                    <select class="form-select form-select-sm" if-destino-step df-destinoId required>
                        ${
                            $ctrl.flowItems.data.map((item)=>{
                                return `<option value="${ item.id }">${ item.name }</option>`;
                            }).join('')
                        }
                    </select>`;

                elem.appendChild(stepSelect);

                return;
            };

            let elem = document.querySelector(`.drawflow-node[id='node-${ nodeRef.id }'] [if-destino]`);
            let hasSelect = elem.querySelector('[df-destinoId]');

            if(nodeRef.data.destino === 'agent'){
                elem.classList.add('d-none');                
                if(hasSelect){ hasSelect.remove(); }

            }else{
                elem.classList.remove('d-none');

                if(nodeRef.data.destino === 'flow'){
                    let hasStep = elem.querySelector('[if-destino-step]');

                    if(!hasSelect){
                        _addFlowSelect();

                        if($ctrl.userFlows.length){
                            $ctrl.drawEditor.updateNodeDataFromId(nodeRef.id, {...nodeRef.data, destinoId: $ctrl.userFlows[0].id });
                        }

                    }else if(hasStep){
                        hasStep.remove();
                        _addFlowSelect();
                    }

                }/* else if(nodeRef.data.destino === 'step'){
                    let hasFlow = elem.querySelector('[if-destino-flow]');

                    if(!hasSelect){
                        _addStepSelect();

                    }else if(hasFlow){
                        hasFlow.remove();
                        _addStepSelect();
                    }
                    
                } */

            }

            refreshConn = true;

        }else if(nodeRef.html === 'condition'){

            const _getRegras=(evento)=>{
                let regras = $ctrl.condicao.regras;

                if(!regras || !evento){
                    return [];
                }
        
                return regras.filter(item=>{ return item.events.includes(evento); });
        
            };
        
            const _getRegraByValue=(value)=>{
                let regras = $ctrl.condicao.regras;

                if(!regras || !value){
                    return {};
                }
        
                let result = regras.filter(item=>{ return item.value === value; });
        
                return result.length ? result[0] : {};
            };

            const _enableElse=(evento)=>{
                let eventos = $ctrl.condicao.eventos;
        
                if(!eventos || !evento){
                    return false;
                }
        
                return eventos.filter(item=> item.value === evento )[0].enableElse;
            };

            const _addRegraSelect=()=>{
                let regraSelect = document.createElement("div");
                regraSelect.innerHTML = `
                    <select class="form-select form-select-sm" df-regra required>
                        ${
                            _getRegras(nodeRef.data.evento).map((item)=>{
                                return `<option value="${ item.value }">${ item.label }</option>`;
                            }).join('')
                        }
                    </select>`;

                regraCondElem.appendChild(regraSelect);

                return;
            };
            
            const _addSubconditionSelect=(subCond)=>{
                let regraSelect = document.createElement("div");

                if(subCond === 'text'){
                    regraSelect.innerHTML = `<input type="text" class="form-control form-control-sm" df-subcondicao placeholder="${$text.writeText}" />`;
                }else if(subCond === 'tag'){
                    regraSelect.innerHTML = `
                    <select class="form-select form-select-sm" df-subcondicao required>
                        ${
                            $ctrl.tags.map((item)=>{
                                return `<option value="${ item.nome }">${ item.nome }</option>`;
                            }).join('')
                        }
                    </select>`;

                    if(!nodeRef.data.subcondicao && $ctrl.tags.length){ nodeRef.data.subcondicao = $ctrl.tags[0].nome; }
                }

                regraSubcondElem.appendChild(regraSelect);

                return;
            };

            /////CONDITION
            let regrasElem = document.querySelector(`.drawflow-node[id='node-${ nodeRef.id }'] [if-hasRegras]`);

            if(!regrasElem){
                return;
            }
            
            let regraCondElem = regrasElem.querySelector('[if-regraCondition]');
            let hasRegra = regraCondElem.querySelector('[df-regra]');

            let regraSubcondElem = regrasElem.querySelector('[if-regraSubcondition]');
            let hasSubCond = regraSubcondElem.querySelector('[df-subcondicao]');

            let eventRegras = _getRegras(nodeRef.data.evento);
            let regraSelected = nodeRef.data.regra;

            if(!eventRegras.length){
                regrasElem.classList.add('d-none');
                hasRegra?.remove();
                hasSubCond?.remove();

            }else{
                regrasElem.classList.remove('d-none');

                if(!regraSelected){
                    hasRegra?.remove();

                    $ctrl.drawEditor.updateNodeDataFromId(nodeRef.id, {...nodeRef.data, regra:eventRegras[0].value});
                    regraSelected = eventRegras[0].value;

                    _addRegraSelect();

                }else if(regraSelected && $ctrl.lastEvent !== nodeRef.data.evento){
                    hasRegra?.remove();
                    
                    _addRegraSelect();
                }

                if($ctrl.lastRegra !== regraSelected){
                    let subCond = _getRegraByValue(regraSelected).subCondition;
                    
                    if(subCond){
                        
                        if(!hasSubCond){
                            $ctrl.drawEditor.updateNodeDataFromId(nodeRef.id, {...nodeRef.data });

                            _addSubconditionSelect(subCond);
    
                        }else if(hasSubCond && $ctrl.lastSubCond !== subCond){
                            hasSubCond?.remove();
                            _addSubconditionSelect(subCond);
                        };
                        
                    }else if(!subCond){
                        hasSubCond?.remove();
                    }

                    $ctrl.lastSubCond = angular.copy(subCond);
                }
                
            }
            
            $ctrl.lastEvent = angular.copy(nodeRef.data.evento);
            $ctrl.lastRegra = angular.copy(regraSelected);
            
            ///Condition Else 
            let elseElem = document.querySelector(`.drawflow-node[id='node-${ nodeRef.id }'] [if-enableElse]`);
            let hasOutput = Object.keys(nodeRef.outputs).includes('output_2');

            if(_enableElse(nodeRef.data.evento)){
                elseElem.classList.remove('d-none');
                if(!hasOutput){ $ctrl.drawEditor.addNodeOutput(id); }
            }else{
                elseElem.classList.add('d-none');
                if(hasOutput){ $ctrl.drawEditor.removeNodeOutput(id, 'output_2'); }                
            }

            $ctrl.drawEditor.updateNodeDataFromId(nodeRef.id, {...nodeRef.data });
            refreshConn = true;

        }else if(nodeRef.html === 'filter'){

            const _getRegras=(evento)=>{
                let regras = $ctrl.filtros.regras;

                if(!regras || !evento){
                    return [];
                }
        
                return regras.filter(item=>{ return item.events.includes(evento); });
        
            };
        
            const _getRegraByValue=(value)=>{
                let regras = $ctrl.filtros.regras;

                if(!regras || !value){
                    return {};
                }
        
                let result = regras.filter(item=>{ return item.value === value; });
        
                return result.length ? result[0] : {};
            };

            const _enableElse=(evento)=>{
                let eventos = $ctrl.filtros.eventos;
        
                if(!eventos || !evento){
                    return false;
                }
        
                return eventos.filter(item=> item.value === evento )[0].enableElse;
            };

            const _addRegraSelect=()=>{
                let regraSelect = document.createElement("div");
                regraSelect.innerHTML = `
                    <select class="form-select form-select-sm" df-regra required>
                        ${
                            _getRegras(nodeRef.data.evento).map((item)=>{
                                return `<option value="${ item.value }">${ item.label }</option>`;
                            }).join('')
                        }
                    </select>`;

                regraCondElem.appendChild(regraSelect);

                return;
            };
            
            const _addSubconditionSelect=(subCond)=>{
                let regraSelect = document.createElement("div");

                if(subCond === 'text'){
                    regraSelect.innerHTML = `<input type="text" class="form-control form-control-sm" df-subcondicao placeholder="${$text.writeText}" />`;
                }else if(subCond === 'tag'){
                    regraSelect.innerHTML = `
                    <select class="form-select form-select-sm" df-subcondicao required>
                        ${
                            $ctrl.tags.map((item)=>{
                                return `<option value="${ item.nome }">${ item.nome }</option>`;
                            }).join('')
                        }
                    </select>`;

                    if(!nodeRef.data.subcondicao && $ctrl.tags.length){ nodeRef.data.subcondicao = $ctrl.tags[0].nome; }
                }

                regraSubcondElem.appendChild(regraSelect);

                return;
            };

            /////FILTER
            let regrasElem = document.querySelector(`.drawflow-node[id='node-${ nodeRef.id }'] [if-hasRegras]`);

            if(!regrasElem){
                return;
            }
            
            let regraCondElem = regrasElem.querySelector('[if-regraCondition]');
            let hasRegra = regraCondElem.querySelector('[df-regra]');

            let regraSubcondElem = regrasElem.querySelector('[if-regraSubcondition]');
            let hasSubCond = regraSubcondElem.querySelector('[df-subcondicao]');

            let eventRegras = _getRegras(nodeRef.data.evento);
            let regraSelected = nodeRef.data.regra;

            if(!eventRegras.length){
                regrasElem.classList.add('d-none');
                hasRegra?.remove();
                hasSubCond?.remove();

            }else{
                regrasElem.classList.remove('d-none');

                if(!regraSelected){
                    hasRegra?.remove();

                    $ctrl.drawEditor.updateNodeDataFromId(nodeRef.id, {...nodeRef.data, regra:eventRegras[0].value});
                    regraSelected = eventRegras[0].value;
                    _addRegraSelect();

                }else if(regraSelected){
                    hasRegra?.remove();
                    _addRegraSelect();
                }

                let subCond = _getRegraByValue(regraSelected).subCondition;
                
                if(subCond){

                    if(!hasSubCond){
                        _addSubconditionSelect(subCond);

                    }else if(hasSubCond && $ctrl.lastSubCond !== subCond){
                        hasSubCond?.remove();

                        _addSubconditionSelect(subCond);
                    };
                    
                }else if(!subCond){
                    hasSubCond?.remove();
                }

                $ctrl.lastSubCond = angular.copy(subCond);
                
            }
            
            ///Filter Else 
            let elseElem = document.querySelector(`.drawflow-node[id='node-${ nodeRef.id }'] [if-enableElse]`);
            let hasOutput = Object.keys(nodeRef.outputs).includes('output_2');

            if(_enableElse(nodeRef.data.evento)){
                elseElem.classList.remove('d-none');
                if(!hasOutput){ $ctrl.drawEditor.addNodeOutput(id); }
            }else{
                elseElem.classList.add('d-none');
                if(hasOutput){ $ctrl.drawEditor.removeNodeOutput(id, 'output_2'); }                
            }

            $ctrl.drawEditor.updateNodeDataFromId(nodeRef.id, {...nodeRef.data });
            refreshConn = true;

        }else if(nodeRef.html === 'aiDecider'){

            if(initial){
                ///reindexa os intents
                let obj = {};
                Object.keys(nodeRef.data.intent).forEach((key, idx)=>{ obj[idx + 1] = nodeRef.data.intent[key]; });
                nodeRef.data.intent = obj;
            }

            Object.keys(nodeRef.data.intent).forEach(key=>{
                let label = `intent-${ key }`;

                let hasIntent = document.querySelector(`.drawflow-node[id='node-${ nodeRef.id }'] [id='${label}']`);
                if(!hasIntent){
                    let intentHtml = `
                        <div class="position-relative mt-2">
                            <input type="text" class="form-control form-control-sm" df-${ label } placeholder="${ $text.writeText }" maxlenght="35" />
                            <button type="button" class="btn btn-icon avtar-xs bg-dark text-white position-absolute end-0 top-0 me-1 ${ label }" style="margin-top:6px;" act-remove-intent>
                                <i class="ph-duotone ph-x text-danger ${ label }"></i>
                            </button>
                        </div>
                    `;

                    let intentElem = document.createElement('div');
                    intentElem.id = label;
                    intentElem.innerHTML = intentHtml;

                    let elem = document.querySelector(`.drawflow-node[id='node-${ nodeRef.id }'] [if-intents]`);
                    elem.appendChild(intentElem);

                    $ctrl.drawEditor.updateNodeDataFromId(nodeRef.id, nodeRef.data);
                }

            });

            refreshConn = true;

        }else if(['image', 'video', 'file', 'audio' ].includes(nodeRef.html)){
            const _loadingFile=(value)=>{
                let loadingElem = document.querySelector(`.drawflow-node[id='node-${ nodeRef.id }'] [if-loading-file]`);
                if(value){
                    loadingElem.classList.remove('d-none');
                }else{
                    loadingElem.classList.add('d-none');
                }
            };

            const _submitFile=()=>{
                let fileInput = document.querySelector(`.drawflow-node[id='node-${ nodeRef.id }'] [df-file]`);

                if(fileInput.files.length){
                    _loadingFile(true);

                    let fileType = fileInput.files[0].type;
                    let fileName = fileInput.files[0].name;   

                    $fb.storage.upload(`/flows/${$ctrl.idUsuario}/${fileType}`, fileInput.files[0], undefined)
                    .then((url) => { 
                        $ctrl.drawEditor.updateNodeDataFromId(nodeRef.id, {file:null, url: url, mimeType:fileType, fileName: fileName});
                        _loadingFile(false);
                        _checkDomChanges(id);

                    }).catch(e=>{ console.log(e); });
                }
            };

            const _showFileElement=(type)=>{
                let html = '';

                if(type === 'image'){
                    html = `
                    <div style="min-height: 110px; position: relative;" if-has-file>
                        <button type="button" class="btn btn-icon avtar-s bg-light-danger position-absolute end-0 top-0 mt-1 me-1" act-remove-file>
                            <i class="ph-duotone ph-x"></i>
                        </button>

                        <img class="w-100" src="${ nodeRef.data.url }" />
                    </div>`;
                }else if(type === 'video') {
                    html = `
                    <div style="min-height: 110px; position: relative;" if-has-file>
                        <button type="button" class="btn btn-icon avtar-s bg-light-danger position-absolute end-0 top-0 mt-1 me-1" act-remove-file>
                            <i class="ph-duotone ph-x"></i>
                        </button>

                        <video class="w-100" controls>
                            <source src="${ nodeRef.data.url }" type="${ nodeRef.data.mimeType}">
                            Your browser does not support video 
                        </video>
                    </div>`;
                }else if(type === 'audio') {
                    html = `
                    <div style="min-height: 110px; position: relative;" if-has-file>
                        <div class="mb-3">
                            <label>${ $text.timeRecording }</label>
                            <input type="number" class="form-control form-control-sm" df-tempo min="0" />
                        </div>

                        <button type="button" class="btn btn-icon avtar-s bg-light-danger position-absolute end-0 top-0 mt-1 me-1" act-remove-file>
                            <i class="ph-duotone ph-x"></i>
                        </button>

                        <audio class="w-100" controls style="margin-top:40px;">
                            <source src="${ nodeRef.data.url }" type="${ nodeRef.data.mimeType }">
                            Your browser does not support audio
                        </audio>
                    </div>`;
                }else if(type === 'file') {
                    html = `
                    <div style="min-height: 110px; position: relative;" if-has-file>
                        <button type="button" class="btn btn-icon avtar-s bg-light-danger position-absolute end-0 top-0 mt-1 me-1" act-remove-file>
                            <i class="ph-duotone ph-x"></i>
                        </button>

                        <div class="border d-flex align-items-center p-2" style="height:110px; border-radius:10px;">
                            <i class="fs-1 ph-duotone ph-file-text me-3"></i>
                            <span>${ nodeRef.data.fileName }</span>
                        </div>
                    </div>`;
                }

                let elem = document.createElement('div');
                elem.innerHTML = html;

                let wrapperElem = document.querySelector(`.drawflow-node[id='node-${ nodeRef.id }'] [file-wrapper]`);
                wrapperElem.appendChild(elem);

            };

            let fileElem = document.querySelector(`.drawflow-node[id='node-${ nodeRef.id }'] [if-empty-file]`);
            let hasfileElem = document.querySelector(`.drawflow-node[id='node-${ nodeRef.id }'] [if-has-file]`);

            if(nodeRef.data.file){
                _submitFile();

            }else if(nodeRef.data.url){               
                if(!hasfileElem){
                    fileElem.classList.add('d-none');
                    _showFileElement(nodeRef.html);

                    if(nodeRef.html === 'audio'){
                        $ctrl.drawEditor.updateNodeDataFromId(nodeRef.id, nodeRef.data);
                    }
                }

            }else{
                fileElem.classList.remove('d-none');
                hasfileElem?.remove();
            }

            refreshConn = true;
        }else if(nodeRef.html === 'tags'){

            let hasTags = document.querySelector(`.drawflow-node[id='node-${ nodeRef.id }'] [df-tag]`);
            hasTags?.remove();

            let tagOptions = document.createElement('select');

            tagOptions.innerHTML = `
                <select class="form-select form-select-sm" df-tag required>
                    ${
                        $ctrl.tags.map((item)=>{
                            return `<option value="${ item.nome }">${ item.nome }</option>`;
                        }).join('')
                    }
                </select>`;

            tagOptions.classList.add('form-select', 'form-select-sm');
            tagOptions.setAttribute('df-tag', '');
            tagOptions.required = true;

            let elem = document.querySelector(`.drawflow-node[id='node-${ nodeRef.id }'] [tags-selector]`);
            elem.prepend(tagOptions);

            let tag = nodeRef.data.tag;

            if($ctrl.cfgTags.show === true){
                tag = $ctrl.cfgTags.dados.nome 
            }
            
            $ctrl.drawEditor.updateNodeDataFromId(nodeRef.id, {...nodeRef.data, tag: tag });

        }

        if(nodeRef.data.nomeModelo){
            let title = document.querySelector(`.drawflow-node[id='node-${ nodeRef.id }'] .item-title`);
            title.textContent = nodeRef.data.nomeModelo;
        };

        if($ctrl.viewMode){
            let elem = document.querySelector(`.drawflow-node[id='node-${ nodeRef.id }'] .leads-in-step`);

            if(elem && $ctrl.leads.length){
                let leadsQtd = $ctrl.leads[id] || 0;

                if(leadsQtd){
                    elem.classList.remove('d-none');

                    let indicator = `<span class="fs-3 me-3 text-white">${$filter('number')(leadsQtd)}</span>`;

                    if(nodeRef.html !== 'start'){ indicator += `<span class="badge bg-light-success fs-5">${ $filter('number')(( leadsQtd * 100) / $ctrl.leads[1], 2) }%</span>`; }

                    elem.innerHTML = id === '1' ? leadsQtd : indicator;

                }else{
                    elem.classList.add('d-none');
                }
            }

            refreshConn = true;
        };

        if(refreshConn){
            $ctrl.drawEditor.updateConnectionNodes('node-'+id);
        };

        return;

    };

    const _deciderAddIntent=(id)=>{
        let nodeRef = $ctrl.drawEditor.getNodeFromId(id);

        let nextIdx = parseInt(Object.keys(nodeRef.data.intent).length) +1; //parseInt(Object.keys(nodeRef.data.intent).at(-1)) + 1;
        let label =  `intent-${ nextIdx }`;

        if(nextIdx > 21){
            return;
        }

        $ctrl.drawEditor.addNodeOutput(id);
        $ctrl.drawEditor.updateNodeDataFromId(nodeRef.id, {...nodeRef.data, intent:{...nodeRef.data.intent, [nextIdx]:null }});

        let intentHtml = `
            <div class="position-relative mt-2">
                <input type="text" class="form-control form-control-sm" df-${ label } placeholder="${ $text.writeText }" maxlenght="35" />
                <button type="button" class="btn btn-icon avtar-xs text-white position-absolute end-0 top-0 me-1 ${ label }" style="margin-top:6px;" act-remove-intent>
                    <i class="ph-duotone ph-x text-danger ${ label }"></i>
                </button>
            </div>
        `;

        let intentElem = document.createElement('div');
        intentElem.id = label;
        intentElem.innerHTML = intentHtml;

        let elem = document.querySelector(`.drawflow-node[id='node-${ nodeRef.id }'] [if-intents]`);
        elem.appendChild(intentElem);
    };

    const _deciderRemoveIntent=(id, event)=>{
        try{
            let nodeRef = $ctrl.drawEditor.getNodeFromId(id);
            let intentClass = null;

            event.target.classList.forEach(item=>{ if(item.includes('intent-')){ intentClass = item; } });

            if(!intentClass){
                return;
            }

            let intentIdx = parseInt(intentClass.replace('intent-', ''));

            let intentElem = document.querySelector(`.drawflow-node[id='node-${ nodeRef.id }'] [id='${intentClass}']`);

            if(intentElem){
                intentElem.remove();

                delete nodeRef.data.intent[intentIdx];                
                $ctrl.drawEditor.removeNodeOutput(id,  `output_${intentIdx}`);
                $ctrl.drawEditor.updateNodeDataFromId(nodeRef.id, {...nodeRef.data});

                //_checkDomChanges(nodeRef.id, true);
            }

            return;

        }catch(e){
            console.log(e);
        }
        
    };

    const _fileRemove=(id)=>{
        $ctrl.drawEditor.updateNodeDataFromId(id, {url:null, file:null, mimeType:null, fileName:null, tempo:0});
        _checkDomChanges(id);
    };

    ////ITEMS Actions
    const _addItem=(itemRef)=>{
        const _getCanvasCenter=()=>{
            const { width, height } = $ctrl.drawEditor.container.getBoundingClientRect();
            const x = width / 2;
            const y = height /2;

            let pos_x = x * ( $ctrl.drawEditor.precanvas.clientWidth / ($ctrl.drawEditor.precanvas.clientWidth * $ctrl.drawEditor.zoom)) - ($ctrl.drawEditor.precanvas.getBoundingClientRect().x * ( $ctrl.drawEditor.precanvas.clientWidth / ($ctrl.drawEditor.precanvas.clientWidth * $ctrl.drawEditor.zoom)));
            let pos_y = y * ( $ctrl.drawEditor.precanvas.clientHeight / ($ctrl.drawEditor.precanvas.clientHeight * $ctrl.drawEditor.zoom)) - ($ctrl.drawEditor.precanvas.getBoundingClientRect().y * ( $ctrl.drawEditor.precanvas.clientHeight / ($ctrl.drawEditor.precanvas.clientHeight * $ctrl.drawEditor.zoom)));

            return {x:pos_x, y:pos_y}
        }

        let centered = _getCanvasCenter();
        centered = {
            x: centered.x - 150,
            y: centered.y - 100
        };

        $ctrl.drawEditor.addNode(itemRef.name, Object.keys(itemRef.inputs).length, Object.keys(itemRef.outputs).length, centered.x, centered.y, itemRef.class, angular.copy(itemRef.data), itemRef.html, true);
        
        ///Adiciona conexão com último item
        //$ctrl.drawEditor.addConnection(lastRef.id, $ctrl.drawEditor.nodeId-1, 'output_1', 'input_1');
    };

    const _removeItem=(id)=>{
        $ctrl.drawEditor.removeNodeId('node-'+id);
    };
    
    const _copyItem=(id)=>{
        let nodeRef = $ctrl.drawEditor.getNodeFromId(id);
        _addItem(nodeRef);
    };
    
    const _addAsModel=(id)=>{
        let nodeRef = $ctrl.drawEditor.getNodeFromId(id);
        
        $ctrl.cfgModelo.show = true;
        $ctrl.cfgModelo.dados = nodeRef;
        $ctrl.cfgModelo.invalid = false;
    };

    ///Model
    const _saveAsModel=()=>{
        if(!$ctrl.cfgModelo.dados.nomeModelo){
            $ctrl.cfgModelo.invalid = true;
            return;
        }

        $ctrl.cfgModelo.isLoading = true;

        let defaultIcon = $ctrl.flowDefaults.filter(item=> item.type === $ctrl.cfgModelo.dados.html)[0].icon;
        let obj = {
            title: $ctrl.cfgModelo.dados.nomeModelo || $ctrl.cfgModelo.dados.name,
            icon: defaultIcon,
            type: $ctrl.cfgModelo.dados.html,
            nomeModelo: $ctrl.cfgModelo.dados.nomeModelo,
            value: {
                ...$ctrl.cfgModelo.dados.data,
                nomeModelo:$ctrl.cfgModelo.dados.nomeModelo
            }
        };

        $fb.db.add('cad_modelos', obj).then(doc=>{
            $ctrl.userModels.push({...obj, id: doc.id});
            
            $ctrl.cfgModelo.show = false;
            $ctrl.cfgModelo.dados = {};
            $ctrl.cfgModelo.invalid = false;
            $ctrl.cfgModelo.isLoading = false;
        });
    };

    $ctrl.deleteModel=(item)=>{
        $dialog.show($text.deleteModel, $text.confirmDeletion, $text.yes, $text.no, null).then(async()=>{
            $fb.db.del('cad_modelos/'+item.id).then(()=>{
                _getModelos();
            });
        });
    };

    ///Node events    
    const _nodeClicked=(event)=>{
        $timeout(()=>{
            if($ctrl.selectedNode){
                if(event.target.closest('.node-remove')){
                    _removeItem($ctrl.selectedNode);
                    
                }else if(event.target.closest('.node-copy')){
                    _copyItem($ctrl.selectedNode);

                }else if(event.target.closest('.node-saveAsModel')){
                    _addAsModel($ctrl.selectedNode);

                }else if(event.target.closest('[act-add-intent]')){
                    _deciderAddIntent($ctrl.selectedNode);

                }else if(event.target.closest('[act-remove-intent]')){
                    _deciderRemoveIntent($ctrl.selectedNode, event);
                }else if(event.target.closest('[act-remove-file]')){
                    _fileRemove($ctrl.selectedNode);
                };
            };

        }, 300);
    };

    const _nodeCreated=(id)=>{
        let nodeRef = $ctrl.drawEditor.getNodeFromId(id);
    };

    const _setFlowNodes=()=>{
        return new Promise((resolve, reject)=>{

            let itemsQtd = Object.keys($ctrl.flowItems.data).length;

            if(!itemsQtd){
                $ctrl.drawEditor.addNode('Início', 0, 1, 300, 120, 'flow-start', {}, 'start', true);
                
                $ctrl.drawEditor.addNode('Gatilho', 1, 1, 380, 70, 'flow-item condition', {"evento": "addContact"}, 'condition', true);

                $ctrl.drawEditor.addConnection("1", "2", "output_1", "input_1");

                $scope.$apply(()=>{ $ctrl.loadingFlow = false; });
                return;
            }

            $ctrl.flowItems.data = _reindex($ctrl.flowItems.data);
            $ctrl.drawEditor.import({drawflow:{Home:$ctrl.flowItems}});

            if(itemsQtd>5){
                for(let i = 0; i < 25;i++){ $ctrl.drawEditor.zoom_out(); }
            }

            Object.keys($ctrl.flowItems.data).forEach(itemId=>{ 
                _checkDomChanges(itemId, true);
            });

            $ctrl.drawEditor.on('nodeCreated', _checkDomChanges);

            resolve();
        });
        
    };

    const _loadFlowItems=async()=>{
        $ctrl.loadingFlow = true;
        
        _getDominio().then(()=>{
            _regDefaultNodes();
            return _setFlowNodes();

        }).then(()=>{
            $scope.$apply(()=>{ $ctrl.loadingFlow = false; });
        });
    };

    //Connection events
    const _connAdded=(conn)=>{
        let nodeRef = $ctrl.drawEditor.getNodeFromId(conn.output_id);

        ///Evita conexão secundária de um node
        if(nodeRef.outputs[conn.output_class].connections && nodeRef.outputs[conn.output_class].connections.length > 1){
            $ctrl.drawEditor.removeSingleConnection(conn.output_id, conn.input_id, conn.output_class, conn.input_class);
        }
    };

    const _connRemoved=(conn)=>{
        if(conn.output_id === "1"){
            ///Evita exclusão da conexão inicial
            $ctrl.drawEditor.addConnection(conn.output_id, conn.input_id, conn.output_class, conn.input_class);
        }
    };

    ///Tags
    const _confirmTags=()=>{
        $fb.db.add('cad_tags', $ctrl.cfgTags.dados).then((res)=>{
            $ctrl.tags.push({nome: $ctrl.cfgTags.dados.nome, cor: $ctrl.cfgTags.dados.cor});
            _checkDomChanges($ctrl.selectedNode);

            $ctrl.cfgTags.show = false;
            $ctrl.cfgTags.isLoading=false;
            $ctrl.cfgTags.dados = {};
        });
    };

    $ctrl.setTab=(tab)=>{
        $ctrl.activeTab = tab;
    };

    $ctrl.addItem=(item)=>{
        let obj = angular.copy(item);

        let newNode = {
            name: obj.nomeModelo || obj.title, 
            inputs: obj.inputs || {input_1:''}, 
            outputs: obj.outputs || {output_1:''}, 
            class:'flow-item '+obj.type,
            data: obj.value || {}, 
            html: obj.type
        };

        _addItem(newNode);
    };

    $ctrl.addTag=()=>{
        $ctrl.cfgTags.show = true;
    };

    $ctrl.cfgTags = {
        show:false,
        dados: {},
        isLoading:false,
        confirm: _confirmTags
    };

    $ctrl.cfgModelo = {
        show: false,
        isLoading: false,
        title: $text.saveAsModel,
        dados: {},
        submit: _saveAsModel
    };

    const _drawflowCustomize=()=>{
        ///Drawflow options
        $ctrl.drawEditor.force_first_input = true;
        $ctrl.drawEditor.editor_mode = $ctrl.viewMode === false ? 'edit' : 'view';
        $ctrl.drawEditor.zoom_min = 0.1;
        $ctrl.drawEditor.zoom_max = 1;
        $ctrl.drawEditor.zoom_value = 0.02;

        ///Funções de nodes
        $ctrl.drawEditor.on('nodeSelected', (id)=>{$ctrl.selectedNode=id;});
        $ctrl.drawEditor.on('nodeUnselected', ()=>{$ctrl.selectedNode=null;});
        $ctrl.drawEditor.on('click', _nodeClicked);
        $ctrl.drawEditor.on('nodeDataChanged', _checkDomChanges);
        //$ctrl.drawEditor.on('nodeCreated', _nodeCreated);

        ///Evita exclusão de nodes iniciais
        $ctrl.drawEditor.removeNodeId=(id)=>{
            if(['node-1', 'node-2'].includes(id)){ return; };

            $ctrl.drawEditor.removeConnectionNodeId(id);
            var moduleName = $ctrl.drawEditor.getModuleFromNodeId(id.slice(5))
            if($ctrl.drawEditor.module === moduleName) {
                $ctrl.drawEditor.container.querySelector(`#${id}`).remove();
            }
            delete $ctrl.drawEditor.drawflow.drawflow[moduleName].data[id.slice(5)];
            $ctrl.drawEditor.dispatch('nodeRemoved', id.slice(5));
        };

        ///Exibe ícone exclusão de conexão ao selecionar
        $ctrl.drawEditor.on("clickEnd", (e)=>{
            if(e.target.classList[0] === "main-path") { $ctrl.drawEditor.contextmenu(e); }
        });

        $ctrl.drawEditor.on('connectionCreated', _connAdded);
        $ctrl.drawEditor.on('connectionRemoved', _connRemoved);

        ///Multi selection
        const nodesSelected = [];
        $ctrl.drawEditor.on("clickEnd", (e) => {
            const shiftKey = e.shiftKey;

            if(shiftKey) {
                if($ctrl.drawEditor.node_selected !== null) {
                    const nodeId = $ctrl.drawEditor.node_selected.id.slice(5);
                    const indexSelected = nodesSelected.indexOf(nodeId);
                    if(indexSelected === -1) {
                        nodesSelected.push(nodeId);
                    } else {
                        nodesSelected.splice(indexSelected,1);
                        const nodeUnselected = document.getElementById(`node-${nodeId}`);
                        if(nodeUnselected){ nodeUnselected.classList.remove("selected"); }
                    }

                } else {
                    nodesSelected.forEach(eleN => {
                        const node = document.getElementById(`node-${eleN}`);
                        if(node){ node.classList.remove("selected"); }
                    });

                    nodesSelected.splice(0, nodesSelected.length);
                }

                nodesSelected.forEach(eleN => {
                    const node = document.getElementById(`node-${eleN}`);
                    if(node){ node.classList.add("selected"); }
                });
            } else {
                nodesSelected.forEach(eleN => {
                    const node = document.getElementById(`node-${eleN}`);
                    if(node){ node.classList.remove("selected"); }
                });

                nodesSelected.splice(0, nodesSelected.length);
            }
            
        });

        let last_x = 0;
        let last_y = 0;
        $ctrl.drawEditor.on("mouseMove", ({x,y}) => {
            if($ctrl.drawEditor.node_selected && $ctrl.drawEditor.drag) {
                $ctrl.drawEditor.node_selected.classList.add("selected");
                const nodeId = $ctrl.drawEditor.node_selected.id.slice(5);
                const indexSelected = nodesSelected.indexOf(nodeId);
                if(indexSelected === -1) {
                    nodesSelected.push(nodeId);
                }
                nodesSelected.forEach(eleN => {
                    if(eleN != $ctrl.drawEditor.node_selected.id.slice(5)) {
                    const node = document.getElementById(`node-${eleN}`);
                    var xnew = (last_x - x) * $ctrl.drawEditor.precanvas.clientWidth / ($ctrl.drawEditor.precanvas.clientWidth * $ctrl.drawEditor.zoom);
                    var ynew = (last_y - y) * $ctrl.drawEditor.precanvas.clientHeight / ($ctrl.drawEditor.precanvas.clientHeight * $ctrl.drawEditor.zoom);

                    node.style.top = (node.offsetTop - ynew) + "px";
                    node.style.left = (node.offsetLeft - xnew) + "px";

                    $ctrl.drawEditor.drawflow.drawflow[$ctrl.drawEditor.module].data[eleN].pos_x = (node.offsetLeft - xnew);
                    $ctrl.drawEditor.drawflow.drawflow[$ctrl.drawEditor.module].data[eleN].pos_y = (node.offsetTop - ynew);
                    $ctrl.drawEditor.updateConnectionNodes(`node-${eleN}`);
                    }
                });
            }
            last_x = x;
            last_y = y;
        });
    };

    $ctrl.$onInit=()=>{
        $ctrl.idUsuario = $fb.auth.getIdToken().claims.idUsuario;

        var id = document.getElementById("drawflow");
        $ctrl.drawEditor = new Drawflow(id);
        
        _drawflowCustomize();

        $ctrl.drawEditor.start();

        _loadFlowItems();

        $ctrl.setTab('basicos');

        $ctrl.exportData=$ctrl.drawEditor;
    };

}]);